export const SOCIAL_ICON_EXT: Record<string, string> = {
  instagram: 'png',
  xiaohongshu: 'svg',
}
